<template>
  <div class="doge-shell">
    <header class="doge-top"><button class="doge-back" @click="$router.back()">‹</button><h1 class="doge-title">邀请</h1><div class="doge-placeholder"></div></header>
    <main class="doge-page-pad">
      <section class="invite-card">
        <img src="@/assets/img/doge-slices/icon-doge.png" class="logo">
        <h2>携手DOGE</h2><h2>共创辉煌</h2>
        <div class="qr" :class="{disabled: !hasInviteCode}">
          <img v-if="hasInviteCode" :src="qr">
          <span v-else>暂无邀请码</span>
        </div>
      </section>
      <div class="orange-line"></div>
      <section class="invite-info">
        <div><p>邀请码</p><b>{{ inviteCode || '请先连接钱包/登录' }}</b><button class="doge-copy" :disabled="!hasInviteCode" @click="copy(inviteCode)">复制</button></div>
        <div><p>邀请链接</p><b>{{ hasInviteCode ? shortLink : '暂无邀请链接' }}</b><button class="doge-copy" :disabled="!hasInviteCode" @click="copy(inviteLink)">复制</button></div>
      </section>
    </main>
    <BottomNav/>
  </div>
</template>
<script>
import BottomNav from '../../components/layout/BottomNav.vue';
import { mapGetters } from 'vuex';
export default {
  name: 'InvitePage',
  components: { BottomNav },
  computed: {
    ...mapGetters(['getUserDetails']),
    inviteCode() {
      const user = this.getUserDetails || {};
      return user.inviteCode || user.invite_code || user.extension_code || user.authorization_code || '';
    },
    hasInviteCode() { return !!this.inviteCode; },
    inviteLink() { return this.hasInviteCode ? location.origin + '/?inviteCode=' + this.inviteCode : ''; },
    shortLink() { return this.inviteLink.replace(/^https?:\/\//, '').slice(0, 18) + '...'; },
    qr() { return 'https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=' + encodeURIComponent(this.inviteLink); }
  },
  methods: {
    copy(t) {
      if (!t) return this.msg('暂无可复制内容');
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(t).then(() => this.msg('复制成功', 'success')).catch(() => this.fallbackCopy(t));
      } else {
        this.fallbackCopy(t);
      }
    },
    fallbackCopy(t) {
      const el = document.createElement('textarea');
      el.value = t;
      el.setAttribute('readonly', 'readonly');
      el.style.position = 'fixed';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      try { document.execCommand('copy'); this.msg('复制成功', 'success'); }
      catch (e) { this.msg('复制失败，请长按链接手动复制', 'error'); }
      document.body.removeChild(el);
    },
    msg(t, type = 'info') { this.$messageDialog ? this.$messageDialog.alert(t, '提示', type) : alert(t); }
  }
};
</script>
<style scoped>.invite-card{background:#fff;border-radius:24px;padding:28px 18px;text-align:center;box-shadow:0 8px 20px rgba(75,52,0,.055)}.logo{width:88px;height:88px;object-fit:contain;margin-bottom:18px}.invite-card h2{color:var(--doge-primary);font-size:28px;margin:8px 0}.qr{width:220px;height:220px;background:#fff;border-radius:18px;padding:12px;margin:24px auto 0;display:flex;align-items:center;justify-content:center;color:#6b7280;font-weight:700;border:1px solid #eee2c7}.qr.disabled{background:#fff8e8;color:#8b806d}.qr img{width:100%;height:100%}.orange-line{height:4px;background:var(--doge-primary);border-radius:4px;margin:18px 40px}.invite-info{background:#fff;border-radius:18px;display:grid;grid-template-columns:1fr 1fr;padding:18px 0;box-shadow:0 6px 18px rgba(75,52,0,.07)}.invite-info div{padding:0 16px;text-align:center}.invite-info div:first-child{border-right:1px solid var(--doge-line)}.invite-info p{color:#8b806d;margin:0 0 10px}.invite-info b{display:block;color:#211507;margin-bottom:8px;word-break:break-all}.doge-copy:disabled{opacity:.45}</style>
